<template>
  <div class="pagination">
    <v-keypress :key-code="37" event="keyup" @pressed="goBack" />
    <v-keypress :key-code="39" event="keyup" @pressed="goForward" />

    <button class="pagination__prev" @click="goBack">Prev</button>
    <div class="pagination__text" @click="$emit('click')">Pill {{ valueFormatted }}/{{ itemsFormatted }}</div>
    <slot>
      <div class="pagination__dots">
        <div class="pagination__dot" v-for="index in items" :key="index">
          <button :class="{ active: index - 1 === value }" @click="$emit('input', index - 1)">
            Dot
          </button>
        </div>
      </div>
    </slot>
    <button class="pagination__next" @click="goForward">Next</button>
  </div>
</template>

<script>
import VKeypress from "@/components/v-keypress";

export default {
  components: {
    VKeypress
  },
  props: {
    items: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    valueFormatted() {
      const v = this.value + 1;
      return v > 9 ? v : "0" + v;
    },
    itemsFormatted() {
      return this.items > 9 ? this.items : "0" + this.items;
    }
  },
  methods: {
    goBack() {
      this.$emit("input", this.value === 0 ? this.items - 1 : this.value - 1);
    },
    goForward() {
      this.$emit("input", this.value === this.items - 1 ? 0 : this.value + 1);
    }
  }
};
</script>
